/* eslint-disable */
import { AUTH_PRESENCE_CHANGED_NEXT, AUTH_STATE_CHANGED_NEXT } from './Auth.types';

/** @typedef {EntityServiceData<AuthEntity>} State */
/** @typedef {ActionAny} AuthActions */

/**
 * Create the state for the `authReducer` before `redux-persist` kicks in
 * @param {EntityService} entityService The `EntityService`
 * @returns {State} The initial state before `redux-persist` kicks in
 */
const createPrePersistAuthState = (entityService) => entityService.create().get();

/**
 * Create the `authReducer`
 * @param {InjectablesForReducer} injectables The _injectable_'s required by this reducer
 * @returns {Reducer<State, AuthActions>} The `authReducer`
 */
const authReducer = ({ entityService }) => (state = createPrePersistAuthState(entityService), action) => {
  switch (action.type) {
    case AUTH_PRESENCE_CHANGED_NEXT: {
      const id = state.selectedIds[0];
      if (state.ids.length === 0 || id === undefined) {
        return state;
      }
      const { presence } = action.payload;
      return entityService
        .from(state)
        .updateOne(id, { presence })
        .get();
    }
    case AUTH_STATE_CHANGED_NEXT: {
      if (action.payload === null) {
        return entityService
          .create()
          .loaded()
          .get();
      }
      return entityService
        .create()
        .loaded()
        .addOne(action.payload)
        .selectOne(action.payload.id)
        .get();
    }
    default: {
      return state;
    }
  }
};

export default authReducer;
